import clsx from "clsx";
import ReactSlider from "react-slider";

import { usePreApplyWhereQuery } from "@/features/common/hooks/usePreApplyWhereQuery";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { JobListFilterProps } from "@/features/job/types/JobListFilterProps";
import {
  JobOrderByWithRelationInput,
  JobWhereInput,
} from "@/generated/graphql-hooks";

const MAX_JOB_PRICE_FITLER_VALUE = 5000;
const MIN_JOB_PRICE_FITLER_VALUE = 0;

// @todo extract common slider component
export const JobPriceFilter = ({ labelClassName }: JobListFilterProps) => {
  const { preApplyWhere, setPreApplyWhere } =
    usePreApplyWhereQuery<JobWhereInput>();
  const { setWhere } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();
  const priceInput = preApplyWhere?.price;
  const lowestPrice = priceInput?.gte ?? MIN_JOB_PRICE_FITLER_VALUE;
  const highestPrice = priceInput?.lte ?? MAX_JOB_PRICE_FITLER_VALUE;

  return (
    <div className="space-y-4 pb-3">
      <div
        className={clsx("text-base font-light text-gray-900", labelClassName)}
      >
        {`$${lowestPrice} ~ ${
          highestPrice === MAX_JOB_PRICE_FITLER_VALUE
            ? "MAX"
            : `$${highestPrice}`
        }`}
      </div>
      <ReactSlider
        className="flex items-center"
        value={[
          priceInput?.gte ?? MIN_JOB_PRICE_FITLER_VALUE,
          priceInput?.lte ?? MAX_JOB_PRICE_FITLER_VALUE,
        ]}
        min={MIN_JOB_PRICE_FITLER_VALUE}
        max={MAX_JOB_PRICE_FITLER_VALUE}
        step={10}
        renderThumb={(props) => (
          <span
            {...props}
            className="border-primary h-4 w-4 rounded-full border-[2px] bg-white focus:outline-none"
          />
        )}
        renderTrack={(props, state) => (
          <span
            {...props}
            className={clsx(
              state.index === 0 || state.index === 2
                ? "bg-gray-300"
                : "bg-primary",
              "h-[2px]",
            )}
          />
        )}
        onAfterChange={() => setWhere(preApplyWhere)}
        onChange={(value: number[]) => {
          setPreApplyWhere({
            ...preApplyWhere,
            price: {
              gte: value[0],
              lte:
                value[1] === MAX_JOB_PRICE_FITLER_VALUE ? undefined : value[1],
            },
          });
        }}
        pearling
      />
    </div>
  );
};
